<template>
  <vue-load-image>
    <img
      slot="image"
      class="block max-w-full p-1 align-middle bg-white border rounded"
      :class="extraClasses"
      :src="src"
      :alt="alt"
    />
    <img
      slot="preloader"
      class="block h-auto max-w-full p-1 align-middle bg-white border rounded"
      :class="extraClasses"
      src="../../assets/moblyv4-loading.gif"
    />
    <img
      slot="error"
      class="block h-auto max-w-full p-1 align-middle bg-white border rounded"
      :class="extraClasses"
      src="../../assets/moblyv4-loading.gif"
    />
  </vue-load-image>
</template>

<script>
import VueLoadImage from 'vue-load-image'
export default {
  name: 'ImgLoadImage',
  components: {
    'vue-load-image': VueLoadImage
  },
  props: {
    src: {
      required: true
    },
    alt: {
      required: false
    },
    extraClasses: {
      type: String,
      default: ''
    }
  }
}
</script>
